import { useEffect, useState } from "react";
import { useAppSelector } from "../../store/hooks/hooks";
import OnBoardingContainer from "@/components/OnboardingContainer";
import LoginForm from "../Onboarding/components/LoginForm";
import { RootState } from "@/store/store";

const Login = () => {
  const settingsState: any = useAppSelector((state: RootState) => state.settings);

  const [showCustomLogin, setShowCustomLogin] = useState(false);

  useEffect(() => {
    if (!settingsState) return;
    const authData = settingsState.settings.auth;

    for (let auth of authData) {
      if (auth.type === "Custom" && auth.enabled) {
        setShowCustomLogin(true);
        break;
      }
    }
  }, [settingsState]);

  if (showCustomLogin) {
    return (
      <OnBoardingContainer>
        <LoginForm />
      </OnBoardingContainer>
    );
  }
  return <></>;
};

export default Login;
